// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDsabz7sSFR-0PCbox28KVOSMiXnh1oFsA",
  authDomain: "mydashboard-1-70746.firebaseapp.com",
  projectId: "mydashboard-1-70746",
  storageBucket: "mydashboard-1-70746.firebasestorage.app",
  messagingSenderId: "16815667685",
  appId: "1:16815667685:web:5d6fdfeddc0fcf4715570c",
  measurementId: "G-XG59K9XV47",
};

const app = initializeApp(firebaseConfig); 

export const requestForToken = async () => {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.log("⚠️ Firebase Messaging not supported in this browser/context");
      return null;
    }

    const messaging = getMessaging(app);
    const token = await getToken(messaging, {
      vapidKey: "BHDGqctk4sYmNRBsRO58v4Y3-mEfhMgBZptze20H4ZKzMqHvxv-ZldqTypW1Lv78qNNlph-mv0YGQlwAVM-jJFo",
    });

    if (token) {
      console.log("✅ FCM Token:", token);
      return token;
    } else {
      console.log("❌ No registration token available. Request permission first.");
      return null;
    }
  } catch (error) {
    console.error("Token error:", error);
    return null;
  }
};

export const getMessagingIfSupported = async () => {
  if (!(await isSupported())) return null;
  return getMessaging(app);
};
